import { ChevronDown } from 'lucide-react';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '~shared/shadcn/ui/collapsible';

import {
  getVisiblePreflightChecks,
  shouldExpandPreflightCategory,
} from '../preflight-check.helpers';
import type { PreflightCheckCategoryProps } from '../preflight-check.types';
import { PreflightCheckItem } from './preflight-check-item';

export const PreflightCheckCategory = ({
  category,
}: PreflightCheckCategoryProps) => {
  const visibleChecks = getVisiblePreflightChecks(category.checks);

  return (
    <Card>
      <Collapsible defaultOpen={shouldExpandPreflightCategory(category.checks)}>
        <CardHeader className='p-0'>
          <CollapsibleTrigger className='group flex w-full items-center justify-between gap-3 px-6 py-6 text-left'>
            <CardTitle className='text-lg'>{category.label}</CardTitle>
            <ChevronDown
              className='size-5 shrink-0 text-muted-foreground transition-transform group-data-[state=open]:rotate-180'
              aria-hidden
            />
          </CollapsibleTrigger>
        </CardHeader>
        <CollapsibleContent>
          <CardContent className='space-y-3'>
            {visibleChecks.map((check) => (
              <PreflightCheckItem key={check.id} check={check} />
            ))}
          </CardContent>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
};
